import { Controller } from 'stimulus';
import porta from 'porta';
import nl from '../i18n/porta/nl';
import en from '../i18n/porta/en';
import de from '../i18n/porta/de';
import toArray from '../helpers/toArray';

class FormValidationController extends Controller {
  connect() {
    let language;
    const htmlLang = document.querySelector('html').lang;

    switch (htmlLang) {
      case 'en':
        language = en;
        break;
      case 'de':
        language = de;
        break;
      case 'be':
        language = nl;
        break;
      default:
        language = nl;
    }

    porta({
      target: this.element,
      messages: language,
      onValidate: (formElement) => {
        this.disableSubmitButton(formElement);
      },
      onError: (formElement) => {
        this.enableSubmitButton(formElement);
      },
      onValid: (formElement) => {
        this.enableSubmitButton(formElement);

        return true;
      },
    });
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line
  toggleSubmitButtonState(formElement, state) {
    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }
}

export default FormValidationController;
